import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import UnChanged from "../tables/Modals/unchanged";

const MainSearch = ({filterby,setFilterBy,editedRows,setEditedRows,searchquery,handlesearchquery}) => {

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const option =[{name:"No Grouping",value:"NO_GROUPING"},{name:"Classification",value:"CLASSIFICATION"},
    {name:"Job Code",value:"JOB"},{name:"Employee",value:"EMPLOYEE"},{name:'Cost Code',value:"COST_CODE"}]
    const options = ["No Grouping", "Grouping", "Classification"];
const [editedmodal,setEditedmodal]=useState(false)
const hasEdits = () => {
    return Object.keys(editedRows).length > 0;
  };
  const allow=()=>{
    setIsDropdownOpen(!isDropdownOpen)
    setEditedmodal(false)
    setEditedRows({})
    
  }
    return (<>
        <div className="flex items-center space-x-4 w-full">
            <div className="flex items-center h-10 rounded-md border border-gray-300 bg-white px-4 flex-grow">
                <FontAwesomeIcon icon={faSearch} className="text-gray-500 mr-2" />
                <input
                value={searchquery}
                onChange={(e)=>handlesearchquery(e)}
                    type="text"
                    placeholder="Search employees..."
                    className="w-full bg-transparent outline-none text-gray-700"
                />
            </div>
            <div className="relative z-30 w-44">
                <button
                    onClick={() => {
                        if(hasEdits()){
                            setEditedmodal(true)
                            return
                        }
                        setIsDropdownOpen(!isDropdownOpen)}}
                    className="flex items-center justify-between w-full h-10 p-2 border border-gray-300 bg-white rounded-md"
                >
                    <span className="text-gray-700">{filterby.name}</span>
                    <FontAwesomeIcon icon={faChevronDown} className="text-gray-500" />
                </button>
                {isDropdownOpen && (
                    <ul className="absolute z-20 w-full bg-white border border-gray-300 rounded-md mt-1 shadow-md">
                        {option.map((option) => (
                            <li
                                key={option.value}
                                onClick={() => {
                                    setFilterBy(option);
                                    setIsDropdownOpen(false);
                                }}
                                className="p-2 text-start hover:bg-gray-100 cursor-pointer text-gray-700"
                            >
                                {option.name}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
        <UnChanged ismodal={editedmodal} setismodal={setEditedmodal} fun={allow}/>
        </>
    );
};

export default MainSearch;
